var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6824 2.66848L7.58406 5.59585C7.11472 5.82114 6.61323 5.87759 6.10202 5.76306C5.76746 5.68811 5.60015 5.65064 5.46544 5.63526C3.79264 5.44423 2.75 6.76817 2.75 8.29062V9.12613C2.75 10.6486 3.79264 11.9725 5.46544 11.7815C5.60015 11.7661 5.76747 11.7286 6.10202 11.6537C6.61323 11.5391 7.11472 11.5956 7.58406 11.8209L13.6824 14.7483C15.0823 15.4203 15.7822 15.7563 16.5627 15.4944C17.3431 15.2325 17.6109 14.6705 18.1467 13.5465C19.6178 10.4603 19.6178 6.95649 18.1467 3.87017C17.6109 2.74625 17.3431 2.18428 16.5627 1.92238C15.7822 1.66049 15.0823 1.99649 13.6824 2.66848Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5033 19.04L9.13626 20.1666C6.05481 17.7227 6.43126 16.5573 6.43126 11.9166H7.47061C7.89238 14.5391 8.88728 15.7813 10.2601 16.6805C11.1057 17.2344 11.28 18.3998 10.5033 19.04Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 11.4584V5.95837",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncements);
export default __webpack_public_path__ + "static/media/announcements.cf6a9888ca08b17041e37df296523e23.svg";
export { ForwardRef as ReactComponent };